import { useMemo } from "react";

export function useDpDisplayOverride(emiResult) {
  return useMemo(() => {
    if (!emiResult) {
      return {
        emi: {
          monthly: null,
          daily: null,
          weekly: null,
        },
        downPayment: null,
        invoiceValue: null,
        loanAmount: null,
      };
    }

    const override = emiResult?.dpDisplayOverride;

    const isOverride =
      override?.when?.dp != null &&
      emiResult?.downPayment != null &&
      override.when.dp === emiResult.downPayment;

    const pick = (overrideVal, baseVal) =>
      isOverride ? (overrideVal ?? baseVal ?? null) : (baseVal ?? null);

    return {
      emi: {
        monthly: pick(override?.emi?.monthly, emiResult?.emi?.monthly),
        daily: pick(override?.emi?.daily, emiResult?.emi?.daily),
        weekly: pick(override?.emi?.weekly, emiResult?.emi?.weekly),
      },
      downPayment: pick(override?.downPayment, emiResult?.downPayment),
      invoiceValue: pick(override?.invoiceValue, emiResult?.invoiceValue),
      loanAmount: pick(override?.loanAmount, emiResult?.loanAmount),
    };
  }, [emiResult]);
}
